import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import { Clapperboard } from "lucide-react";
import CardMedia from "../Media/CardMedia";
import AdMediaPreviewTooltipContent, {
  adMediaPreviewTooltipSlotProps,
} from "./AdMediaPreviewTooltipContent";
import { getValidMediaUrls } from "./adMediaPreviewUtils";
import { PRIMARY_COLOR } from "../../utils/colors";

const sxPreviewWrapper = {
  borderRadius: "4px",
  overflow: "hidden",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(0, 0, 0, 0.08)",
  cursor: "default",
};
const sxCardMedia = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
};
const propsTypePreview = {
  controls: false,
  autoplay: false,
  muted: true,
  loop: false,
};

const AdMediaPreviewIcon = ({ mediaUrls = [], size = 20 }) => {
  const [hasFailedLoad, setHasFailedLoad] = useState(false);
  const validUrls = getValidMediaUrls(mediaUrls);
  const firstUrl = validUrls[0];
  const shouldUseFallback = !validUrls.length || hasFailedLoad;

  useEffect(() => {
    setHasFailedLoad(false);
  }, [firstUrl]);

  if (shouldUseFallback) {
    return <Clapperboard size={size} color={PRIMARY_COLOR} />;
  }

  return (
    <Tooltip
      placement="right"
      slotProps={adMediaPreviewTooltipSlotProps}
      title={<AdMediaPreviewTooltipContent mediaUrls={mediaUrls} />}
      arrow
    >
      <Box
        sx={{
          width: size,
          height: size,
          ...sxPreviewWrapper,
        }}
      >
        <CardMedia
          url={firstUrl}
          onFailedLoadUrl={() => setHasFailedLoad(true)}
          sx={sxCardMedia}
          sxVideo={sxCardMedia}
          propsType={propsTypePreview}
        />
      </Box>
    </Tooltip>
  );
};

export default AdMediaPreviewIcon;
